import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Breadcrumbs from "../../../Common/Breadcrumbs";
import PermissionsFilters from "../../../components/accessManagement/molecules/PermissionsFilters";
import PermissionsTable from "../../../components/accessManagement/organisms/PermissionsTable";
import { useAccessManagementPermissions } from "./useAccessManagementPermissions";
import "../AccessManagement.css";
import "../Users/Users.css";

const AccessManagementPermissionsPage: React.FC = () => {
  const { functions, values, loading, error } =
    useAccessManagementPermissions();

  return (
    <div className="page-content">
      <Container fluid className="feature-management-page">
        {/* Breadcrumbs */}
        <div className="mb-3 mt-4" style={{ padding: "0 15px" }}>
          <Breadcrumbs
            items={[
              { label: "Access Management" },
              { label: "Permissions", active: true },
            ]}
          />
        </div>

        {/* Header + Search */}
        <div style={{ padding: "0 15px", marginBottom: "24px" }}>
          <Row className="align-items-center justify-content-between g-3">
            <Col xs="12" md="auto">
              <h2 className="mb-0">Permissions</h2>
              <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                {loading.isPageLoading
                  ? "Loading..."
                  : `${values.totalCount} permissions`}
              </p>
            </Col>
            <Col xs="12" md={2}>
              <PermissionsFilters
                value={values.search}
                onChange={functions.handleSearchChange}
              />
            </Col>
          </Row>
        </div>

        {/* Permissions table */}
        <div style={{ padding: "0 15px" }}>
          <PermissionsTable
            permissions={values.permissions}
            loading={loading.isPageLoading}
            error={error}
            page={values.page}
            pageSize={values.pageSize}
            totalCount={values.totalCount}
            totalPages={values.totalPages}
            onPageChange={functions.handlePageChange}
            onPageSizeChange={functions.handlePageSizeChange}
          />
        </div>
      </Container>
    </div>
  );
};

export default AccessManagementPermissionsPage;
